import shop from "./shop"; //商品信息
import system from "./system"; //系统设置
import user from "./user"; //系统设置
import bus from "./bus"; //系统设置
import oper from "./oper"; //系统设置
import activity from "./activity.js"; //活动设置
import hotelManage from "./hotel.js"; //活动设置
import takeOut from "./takeOut.js"; //外卖管理
import store from "./store.js"; //店铺管理
import rest from "./rest.js"; //外卖管理
import houseRecommendManage from "./houseRecommendManage.js"; // 推荐房产管理
import homestay from "./homestay.js"; //民宿管理
import statementManage from "./statementManage.js"; //报表管理
import member from "./member.js"; //报表管理
import site from "./site.js"; // 场馆管理
import smartLock from "./smart.js"; //门锁管理
import market from "./market.js"; //营销管理
import plate from "./plate.js"; //停车管理
import social from "./social.js"; //社交管理
import legalright from "./legalright.js"; //权益管理
import coupon from "./coupon.js"; // 优惠券管理
import client from "./client.js"; //客户管理
import storedValue from "./storedValue"; //储值管理
import spacelocation from "./spacelocation.js"; //空间位置管理
import distribution from "./distribution.js"; // 分销
import customerOperation from "./customerOperation.js"; //人群运营
import content from "./content"; // 内容管理
import sale from "./sale"; // 零售管理
// v3 路由引入
import pay from "./router_ports_v3/pay"; // 充值管理
import point from "./router_ports_v3/point"; // 积分管理
import lottery from "./router_ports_v3/lottery"; // 抽奖管理

// 不作为Main组件的子页面展示的页面单独写，如下
export const page404 = {
  path: "/*",
  name: "error-404",
  meta: {
    title: "404-页面不存在",
  },
  component: () => import("../pages/error/404.vue"),
};

export const page403 = {
  path: "/403",
  meta: {
    title: "403-权限不足",
  },
  name: "error-403",
  component: () => import("../pages/error/403.vue"),
};

export const page500 = {
  path: "/500",
  meta: {
    title: "500-服务端错误",
  },
  name: "error-500",
  component: () => import("../pages/error/500.vue"),
};

// 营销活动
//import market from "./router_ports_v3/market/shareActivity"; // 推文管理

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: "/home",
    component: (resolve) =>
      require([
        /* webpackChunkName: "aside" */
        "../components/Home.vue",
      ], resolve),
    redirect: "",
    name: "Property",
    title: "集发",
    children: [
      //系统首页
      {
        path: "/dashboard",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */
            "../components/Dashboard.vue"
            ),
        meta: {title: "系统首页"},
      },
      // 会员设置
      {
        path: "/member",
        component: (resolve) =>
          require(["../pages/memberManage/member.vue"], resolve),
        name: "member",
        redirect: "/memberManage",
        title: "会员管理",
        children: member,
      },
      // 系统设置
      {
        path: "/base",
        component: (resolve) =>
          require(["../pages/system/system.vue"], resolve),
        name: "system",
        redirect: "/organizatioon",
        title: "系统设置",
        children: system,
      },
      // 用户管理
      {
        path: "/userManage",
        component: (resolve) =>
          require(["../pages/userManage/userManage.vue"], resolve),
        name: "/UserManage",
        redirect: "/userMesManage",
        title: "用户管理",
        children: user,
      },
      // 班车管理
      {
        path: "/busManage",
        component: (resolve) =>
          require(["../pages/busManage/busManage.vue"], resolve),
        name: "BusManage",
        redirect: "/lineManage",
        title: "班车管理",
        children: bus,
      },
      // 商城管理
      {
        path: "/shoppingMall",
        component: (resolve) =>
          require(["../pages/shoppingMallManage/shoppingMall.vue"], resolve),
        name: "ShoppingMall",
        redirect: "/mallClassifyManage",
        title: "商城管理",
        children: shop,
      },
      // 运营管理
      {
        path: "/operManage",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "operManage",
        redirect: "/bannerManage",
        title: "运营管理",
        children: oper,
      },
      // 活动管理
      {
        path: "/activitysManage",
        component: (resolve) =>
          require(["../pages/activity/activitysManage.vue"], resolve),
        name: "activitysManage",
        redirect: "/activityClassifyManage",
        title: "活动管理",
        children: activity,
      },
      // 酒店管理
      {
        path: "/hotelManage",
        component: (resolve) =>
          require(["../pages/hotelManage/hotelManage.vue"], resolve),
        name: "hotelManage",
        redirect: "/hotel",
        title: "酒店管理",
        children: hotelManage,
      },
      // 外卖管理
      {
        path: "/takeOut",
        component: (resolve) =>
          require(["../pages/takeOut/takeOut.vue"], resolve),
        name: "takeOut",
        redirect: "/takeOutCate",
        title: "外卖管理",
        children: takeOut,
      },
      // 店铺管理
      {
        path: "/store",
        component: (resolve) => require(["../pages/store/store.vue"], resolve),
        name: "store",
        redirect: "/storeType",
        title: "店铺管理",
        children: store,
      },
      // 餐厅管理
      {
        path: "/restManage",
        component: (resolve) =>
          require(["../pages/restManage/restManage.vue"], resolve),
        name: "RestManage",
        redirect: "/diningRoom",
        title: "餐厅管理",
        children: rest,
      },
      // 推荐房产管理
      {
        path: "/houseRecommendManage",
        component: (resolve) =>
          require([
            "../pages/houseRecommendManage/houseRecommendManage.vue",
          ], resolve),
        name: "HouseRecommendManage",
        redirect: "/houseInfoManage",
        title: "推荐房产管理",
        children: houseRecommendManage,
      },
      // 民宿管理
      {
        path: "/minsuManage",
        component: (resolve) =>
          require(["../pages/homestay/minsuManage.vue"], resolve),
        name: "minsuManage",
        redirect: "/minsuFacilities",
        title: "民宿管理",
        children: homestay,
      },
      // 报表管理
      {
        path: "/statementManage",
        component: (resolve) =>
          require(["../pages/statementManage/statementManage.vue"], resolve),
        name: "StatementManage",
        redirect: "/activityJionStatement",
        title: "推荐房产管理",
        children: statementManage,
      },
      // 场馆管理
      {
        path: "/siteManage",
        component: (resolve) =>
          require(["../pages/siteManage/siteManage.vue"], resolve),
        name: "siteManage",
        redirect: "/site",
        title: "场馆管理",
        children: site,
      },
      // 门禁管理
      {
        path: "/smartLockManage",
        component: (resolve) =>
          require(["../pages/smartLockManage/smart.vue"], resolve),
        name: "SmartLockManage",
        redirect: "/smartLock",
        title: "门禁管理",
        children: smartLock,
      },
      // 营销管理
      {
        path: "/marketingManage",
        component: (resolve) =>
          require(["../pages/marketingManage/marketing.vue"], resolve),
        name: "marketingManage",
        redirect: "/marketing",
        title: "营销管理",
        children: market,
      },
      // 停车管理
      {
        path: "/plateManage",
        component: (resolve) =>
          require(["../pages/plateManage/plate.vue"], resolve),
        name: "plateManage",
        redirect: "/plateManage",
        title: "停车管理",
        children: plate,
      },
      // 社交管理
      {
        path: "/socialManage",
        component: (resolve) =>
          require(["../pages/socialManage/social.vue"], resolve),
        name: "socialManage",
        redirect: "/socialManage",
        title: "社交管理",
        children: social,
      },
      // 优惠券管理
      {
        path: "/coupon",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "coupon",
        redirect: "/couponManage",
        title: "优惠券管理",
        children: coupon,
      },
      //权益管理
      {
        path: "/legalRight",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "/legalRight",
        redirect: "/availableEquity",
        title: "权益管理",
        children: legalright,
      },
      //客户管理
      {
        path: "/client",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "/client",
        redirect: "/clientUserManage",
        title: "客户管理",
        children: client,
      },
      //储值管理
      {
        path: "/storedValue",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "/storedValue",
        redirect: "/fabricationManage",
        title: "储值管理",
        children: storedValue,
      },
      //空间位置管理
      {
        path: "/spaceLocation",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "/spaceLocation",
        redirect: "/civicismKind",
        title: "空间位置管理",
        children: spacelocation,
      },
      {
        path: "/distribution",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "/distribution",
        redirect: "/distributors",
        title: "分销",
        children: distribution,
      },
      {
        path: "/customerOperation",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "/customerOperation",
        redirect: "/crowdOperating",
        title: "客户运营",
        children: customerOperation,
      },
      // 内容管理
      {
        path: "/content",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "content",
        redirect: "/material",
        title: "内容管理",
        children: content,
      },
      {
        path: "/saleSystem",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "SaleSystem",
        redirect: "/mallClassifyManage",
        title: "零售管理",
        children: sale,
      },

      /*************** v3 路由 ****************** */
      // 充值管理
      {
        path: "/pay",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "pay",
        redirect: "/payPrize",
        title: "充值管理",
        children: pay,
      },
      // 积分管理
      {
        path: "/point",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "point",
        redirect: "/rexchangeRecords",
        title: "积分管理",
        children: point,
      },
      // 抽奖管理
      {
        path: "/lottery",
        component: (resolve) => require(["../pages/Main.vue"], resolve),
        name: "lottery",
        redirect: "/lotteryPrize",
        title: "抽奖管理",
        children: lottery,
      }
    ],
  },
  {
    path: "/login",
    component: (resolve) => require(["../pages/login/login.vue"], resolve),
    name: "登录",
    hidden: true,
  },
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [...appRouter, page404, page403, page500];

export const routererror = [page404, page403, page500];
